import {
  Column,
  CreateDateColumn,
  DeleteDateColumn,
  Entity,
  JoinColumn,
  ManyToOne,
  OneToMany,
  PrimaryGeneratedColumn
} from 'typeorm';
import { PEDIDO_NOVO } from '../constants';
import { serialize } from '../helper';
import Cliente from './Cliente';
import Comanda from './Comanda';
import Cupom from './Cupom';
import Endereco from './Endereco';
import ProdutoCompostoNoPedido from './ProdutoCompostoNoPedido';
import ProdutoNoPedido from './ProdutoNoPedido';
import Empresa from './Empresa';
import Entregador from './Entregador';

@Entity()
export class Pedido {
  @PrimaryGeneratedColumn()
  id!: number;

  @Column()
  observacao: string = '';

  @Column()
  precoDelivery: number = 0; // no app sempre uso o precoDelivery da tabela Empresa e depois que o pedido é registrado utilizo esse aqui

  @Column({ default: PEDIDO_NOVO, nullable: false })
  status: string = PEDIDO_NOVO;

  @Column()
  justificativaCancelamento: string = '';

  @Column()
  totalBruto: number = 0;

  @Column()
  valorDesconto: number = 0;

  @Column()
  valorPrePago: number = 0;

  @Column()
  totalLiquido: number = 0;

  @Column()
  tipoPagamento: string = 'CARTAO';

  @Column()
  trocoPara: number = 0;

  @Column()
  feitoPorAdmin: boolean = false;

  @Column()
  feitoPorId?: number;

  @Column()
  clienteId: number = 0;

  @Column()
  empresaId!: number;

  @Column()
  enderecoId!: number;

  @Column()
  entregadorId?: number;

  @Column()
  numeroPedidoEDsys?: string;

  @OneToMany(() => ProdutoNoPedido, (produto: ProdutoNoPedido) => produto.pedido, {
    eager: false,
    cascade: true
  })
  produtosNoPedido!: ProdutoNoPedido[];

  @OneToMany(() => ProdutoCompostoNoPedido, (produto: ProdutoCompostoNoPedido) => produto.pedido, {
    eager: false,
    cascade: true
  })
  produtosCompostosNoPedido!: ProdutoCompostoNoPedido[];

  @ManyToOne(() => Endereco, { eager: false })
  @JoinColumn({ name: 'enderecoId' })
  endereco?: Endereco;

  @ManyToOne(() => Cliente, { eager: false })
  @JoinColumn({ name: 'clienteId' })
  cliente!: Cliente;

  @ManyToOne(() => Cliente, { eager: false })
  @JoinColumn({ name: 'feitoPorId' })
  feitoPor?: Cliente;

  @ManyToOne(() => Entregador, { eager: false })
  @JoinColumn({ name: 'entregadorId' })
  entregador?: Entregador;

  @ManyToOne(() => Cupom, { eager: false })
  cupom?: Cupom;

  @ManyToOne(() => Comanda, { eager: false })
  comanda?: Comanda;

  @ManyToOne(() => Empresa)
  @JoinColumn({ name: 'empresaId' })
  empresa!: Empresa;

  @CreateDateColumn()
  createdAt!: Date;

  @DeleteDateColumn({ select: false })
  deletedAt!: Date;
}

export const criarPedido = () => {
  const pedido = new Pedido();
  pedido.produtosNoPedido = [];
  pedido.produtosCompostosNoPedido = [];
  return serialize<Pedido>(pedido);
};

export default Pedido;
